import { CreateProductButton } from "@/components/product/create-product-button";
import { NoProductFound } from "@/components/product/no-product-found";
import ProductOverviewCard from "@/components/product/product-overview-card";
import DashboardWrapper from "@/components/shared/dashboard_wrapper";
import Page from "@/components/shared/page";
import TitleBar from "@/components/shared/title-bar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";

export function ProductHomePage({
	product_list,
	show_progress_bar = false,
	show_description = true,
	trans_key,
}) {
	// Hooks
	const { t } = useTranslation();

	let isPaidService = true;

	const hasFreeProductsList = ["pbs"];
	if (hasFreeProductsList.includes(trans_key)) {
		isPaidService = false;
	}
	return (
		<Page title={t(`${trans_key}.manage.overview.title`)}>
			<DashboardWrapper is_paid_service_page={isPaidService}>
				<Box position="relative">
					<TitleBar
						title={t(`${trans_key}.manage.overview.title`)}
						actions={<CreateProductButton trans_key={trans_key} />}
					/>

					<Grid container>
						<Grid item xs={12}>
							{product_list?.count > 0 ? (
								<Grid container spacing={2.5}>
									{product_list.data?.map((product) => (
										<ProductOverviewCard
											key={product.id}
											product={product}
											show_progress_bar={show_progress_bar}
											show_description={show_description}
											trans_key={trans_key}
										/>
									))}
								</Grid>
							) : (
								<NoProductFound trans_key={trans_key} />
							)}
						</Grid>
					</Grid>
				</Box>
			</DashboardWrapper>
		</Page>
	);
}
